/* eslint-disable @typescript-eslint/no-require-imports */

import type ExpoTvosTopShelfModule from "$modules/expo-tvos-top-shelf/src/ExpoTvosTopShelfModule";
import CustomPlatform from "$src/core/utils/platform/platform";

export default CustomPlatform.select<() => typeof ExpoTvosTopShelfModule>({
  tvOS: () => require("./src/ExpoTvosTopShelfModule.tv").default,
  default: () => require("./src/ExpoTvosTopShelfModule").default,
})();

// eslint-disable-next-line no-restricted-imports
export type * from "./src/ExpoTvosTopShelf.types";
